<template>
  <p class="error">{{ text }}</p>
</template>

<script>
export default {
  name: 'error-message',
  props: {
    text: String,
  }

}
</script>

<style scoped>
.error {
  width: 95%;
  display: flex;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 700;
  color: red;
  padding: 1rem;
  text-align: center;
  padding-left: 5%;
  margin: 0 !important;
  margin-left: 5% !important;
}
</style>